import { AgentModel } from 'common/data/agent/model';
import { BrokerModel } from 'common/data/broker/model';
import { StatsTealiumDataEmailAgentEventInterface } from 'common/module/stats/tealium/data-layer/agent.event.interface';
import { StatsTealiumDataLayerEventActionEnum } from 'common/module/stats/tealium/data-layer/event-action.enum';
import { StatsTealiumDataLayerEventCategoryEnum } from 'common/module/stats/tealium/data-layer/event-category.enum';
import { StatsTealiumDataLayerEventLabelEnum } from 'common/module/stats/tealium/data-layer/event-label.enum';
import { StatsTealiumDataLayerEventOptionsInterface } from 'common/module/stats/tealium/data-layer/event-options.interface';
import { StatsTealiumDataLayerEventTypeEnum } from 'common/module/stats/tealium/data-layer/event-type.enum';
import { StatsTealiumDataLayerTealiumEventEnum } from 'common/module/stats/tealium/data-layer/tealium-event.enum';

export const StatsTealiumAgentEvent = (
  tealiumEvent: StatsTealiumDataLayerTealiumEventEnum,
  model: AgentModel | BrokerModel,
  options?: StatsTealiumDataLayerEventOptionsInterface
): StatsTealiumDataEmailAgentEventInterface => {
  const tealiumVars: StatsTealiumDataEmailAgentEventInterface = {
    tealium_event: tealiumEvent,
    event_category: options?.eventCategory || StatsTealiumDataLayerEventCategoryEnum.conversion,
    event_action: options?.eventAction || StatsTealiumDataLayerEventActionEnum.email,
    event_label: options?.eventLabel || StatsTealiumDataLayerEventLabelEnum.emailNow,
    event_type: StatsTealiumDataLayerEventTypeEnum.click,
  };

  if (tealiumEvent === StatsTealiumDataLayerTealiumEventEnum.emailNow && options.userInfo) {
    tealiumVars.user_full_name = options.userInfo.user_full_name;
    tealiumVars.user_email = options.userInfo.user_email;
    tealiumVars.user_phone_number = options.userInfo.user_phone_number;
  }

  if (options?.isBroker) {
    const brokerModel = <BrokerModel>model;
    return {
      ...tealiumVars,
      broker_id: brokerModel.id,
      broker_agents_qty: `${brokerModel.agents || 0}`,
      broker_location: brokerModel.location_name,
      broker_name: brokerModel.name,
      broker_properties_qty: `${brokerModel.total_properties}`,
    };
  }

  const agentModel = <AgentModel>model;

  return {
    ...tealiumVars,
    broker_id: agentModel?.broker?.id,
    broker_agents_qty: `${agentModel?.broker?.agents || 0}`,
    broker_location: agentModel?.broker?.location_name,
    broker_name: agentModel?.broker?.name,
    broker_properties_qty: `${agentModel?.broker?.total_properties || 0}`,
    agent_id: agentModel.id,
    agent_languages:
      options?.included?.filter((data) => data.type === 'language')?.map((lang) => lang.attributes.name) || [],
    agent_name: agentModel.name,
    agent_title: agentModel.position,
    agent_user_id: `${agentModel.user_id}`,
    agent_mobile_number: agentModel.phone_did || '',
    agent_super_status: agentModel.is_trusted ? 'true' : 'false',
  };
};
